import { Primitive } from '@rtkwlf/fenrir-react';

import { Error } from '@packages/components/error/Error';
import { PagePlain } from '@packages/fenrir/pages/page-plain';

import { useSecurityJourneyTranslations } from '../../../locales/use-security-journey-translations';

/**
 * See https://reactrouter.com/en/main/hooks/use-route-error
 */
export const SpidrIDPageErrorBoundary = () => {
  /**
   * Init translations
   */
  const { t } = useSecurityJourneyTranslations();

  return (
    <Primitive.div
      padding="medium"
      boxShadow="default"
      alignSelf="stretch"
      backgroundColor="widgetDefault"
      height="full"
    >
      <Error
        title={t('spidrID.error.title.adhocSpidr')}
        message={t('common.tryAgainLater')}
      />
    </Primitive.div>
  );
};

export const ErrorBoundary = () => {
  const { t } = useSecurityJourneyTranslations();
  return (
    <PagePlain title={t('spidrID.spidrs')}>
      <SpidrIDPageErrorBoundary />
    </PagePlain>
  );
};
